
import PropTypes from 'prop-types'
import { List, Button } from 'antd'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  center: {
    textAlign: 'center',
  },
})

export default function Phrases({
  onManage,
  phrases = []
}) {
  const classes = useStyles()

  return (
    <List
      bordered
      dataSource={phrases}
      footer={
        <div className={classes.center}>
          <Button type="link" onClick={onManage}>
            Manage
          </Button>
        </div>
      }
      renderItem={item => <List.Item>{item.value}</List.Item>}
    />
  )
}

Phrases.propTypes = {
  phrases: PropTypes.arrayOf({}),
  onManage: PropTypes.func.isRequired,
}
